const TYPE_STYLE = {
  reservedBlock: "border-[#A0148C]/70",
  outOfService: "border-red-500/70",
  structure: "border-slate-500/60",
};

export default function StructureBlock({ structure, onClick, selected }) {
  const s = structure;
  return (
    <div
      data-testid={`structure-${s.id}`}
      onClick={onClick}
      style={{
        gridColumn: `${s.posX + 1} / span ${s.width}`,
        gridRow: `${s.posY + 1} / span ${s.height}`,
        backgroundColor: s.color || "#334155",
      }}
      className={`flex items-center justify-center rounded-md border-2 p-1 text-center text-[11px] font-bold uppercase tracking-wide text-white/95 shadow-inner ${
        TYPE_STYLE[s.type] || TYPE_STYLE.structure
      } ${selected ? "ring-2 ring-white" : ""} ${onClick ? "cursor-pointer" : ""}`}
    >
      <span className="leading-tight">{s.label}</span>
    </div>
  );
}
